import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'UAE Company Formation',
        link: '/uae-company-formation',
    },
]

function UAECompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>UAE Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Incorporate in the Middle East’s Leading Business Hub
                            </h3>
                            <p className='page-paragraph'>
                                A <b>UAE company</b> provides <b>zero corporate tax</b> (in most Free Zones), <b>100% foreign ownership</b>, and access to <b>global markets</b>. Whether in <b>Dubai, Abu Dhabi, Sharjah, or Ras Al Khaimah (RAK)</b>, the UAE offers a wide range of opportunities for <b>trading, consulting, fintech, crypto, and holding companies</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "100% Foreign Ownership",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "0% Tax (Free Zones)",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking Hub",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Global Market Access",
                                        icon: TiTick,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a UAE Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in the UAE?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Business Hub",
                                    paragraph: "Strategic location between Europe, Asia, and Africa",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Benefits",
                                    paragraph: "0% corporate tax in most Free Zones, no personal income tax",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "Strong network of local & international banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor-Friendly",
                                    paragraph: "100% foreign ownership in Free Zones & Mainland",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Benefits",
                                    paragraph: "Company owners can apply for UAE residency visas",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of UAE Companies</h3>
                        <p className='page-subtitle'>1. Mainland Company</p>
                        <PageList
                            items={[
                                { paragraph: "Can operate across the UAE and internationally.", icon: GoDotFill },
                                { paragraph: "100% foreign ownership now allowed in most sectors.", icon: GoDotFill },
                                { paragraph: "Required for government contracts & retail activities.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Free Zone Company</p>
                        <PageList
                            items={[
                                { paragraph: "Operates within designated Free Zones (Dubai, Abu Dhabi, RAK, Sharjah, etc.).", icon: GoDotFill },
                                { paragraph: "100% foreign ownership, 0% corporate tax (in most Free Zones).", icon: GoDotFill },
                                { paragraph: "Quick setup & modern facilities.", icon: GoDotFill },
                                { paragraph: "Ideal for trading, consulting, fintech, and holding companies.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Offshore Company</p>
                        <PageList
                            items={[
                                { paragraph: "Designed for holding, asset protection, and international trading.", icon: GoDotFill },
                                { paragraph: "Cannot operate locally within UAE.", icon: GoDotFill },
                                { paragraph: "Commonly used in RAK and JAFZA.", icon: GoDotFill },
                            ]}
                        />

                        <h3  className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "Minimum 1",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Minimum 1",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Required within Free Zone/Mainland",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital",
                                    paragraph: "Varies by Free Zone (often minimal, e.g., AED 10,000)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filing",
                                    paragraph: "Depends on structure (audits required for some Free Zones)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3  className='page-title'>
                            Benefits of UAE Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Zero or Low Taxes",
                                    paragraph: "No corporate or personal tax in many zones",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "100% Ownership",
                                    paragraph: "No local partner needed in most cases",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Visa",
                                    paragraph: "Company formation grants access to UAE residency",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Hub",
                                    paragraph: "UAE banks offer global connections",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Lifestyle & Stability",
                                    paragraph: "Safe, modern, and business-friendly",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Choose Structure",
                                    paragraph: "Mainland, Free Zone, or Offshore",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation & Licensing",
                                    paragraph: "Approve trade name & license category",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "M&AA, shareholder KYC, office lease (if required)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registration with Authorities",
                                    paragraph: "Free Zone authority or DED for Mainland",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Opening",
                                    paragraph: "Local or international bank",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Visa Application",
                                    paragraph: "For shareholders & employees",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "1–3 weeks (depending on authority)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 5,000+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "License renewal, registered office, visa renewals",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of UAE Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Consulting & professional services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Trading & import/export",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "FinTech & crypto startups",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding company for assets & investments",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "E-commerce & digital businesses",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Mainland, Free Zone, and Offshore setups",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong partnerships",
                                    paragraph: "Dubai, Abu Dhabi, RAK, Sharjah",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Assistance with banking, visas, and office leasing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "UAE vs Cyprus vs Singapore vs Hong Kong",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Long-term corporate compliance & visa support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a zero-tax, global business hub?"
                        description="A UAE company offers credibility, tax benefits, and residency opportunities — making it one of the most attractive business destinations in the world."
                        buttonText="Book a UAE Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default UAECompanyFormation

const faqData = [
    {
        question: "Can foreigners own 100% of a UAE company?",
        content: [
            { type: "answer", text: "Yes — in Free Zones and in most Mainland sectors." },
        ],
    },
    {
        question: "Do UAE companies pay corporate tax?",
        content: [
            { type: "answer", text: "No in Free Zones (0% tax), but Mainland may be subject to 9% on profits above AED 375,000." },
        ],
    },
    {
        question: "Can I get residency through company formation?",
        content: [
            { type: "answer", text: "Yes — shareholders and employees can obtain UAE residency visas." },
        ],
    },
    {
        question: "How long does it take to register a company?",
        content: [
            { type: "answer", text: "1–3 weeks depending on the jurisdiction." },
        ],
    },
    {
        question: "Can UAE companies open international bank accounts?",
        content: [
            { type: "answer", text: "Yes — UAE companies are widely accepted globally." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We registered our Dubai Free Zone company for fintech operations. Offshore Advisory managed the license, bank account, and visas.",
        author: "Khalid A.",
        role: "FinTech Founder",
    },
    {
        quote:
            "RAK Offshore gave us a cost-effective holding company. Offshore Advisory provided excellent support.",
        author: "Elena G.",
        role: "Investor",
    },
];